var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.624 16.6406V18.8906H6.37402V16.6406H5.24902V18.8906C5.24902 19.189 5.36755 19.4751 5.57853 19.6861C5.78951 19.8971 6.07565 20.0156 6.37402 20.0156H17.624C17.9224 20.0156 18.2085 19.8971 18.4195 19.6861C18.6305 19.4751 18.749 19.189 18.749 18.8906V16.6406H17.624ZM17.624 11.0156L16.8309 10.2225L12.5615 14.4863V4.26562H11.4365V14.4863L7.16715 10.2225L6.37402 11.0156L11.999 16.6406L17.624 11.0156Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.6d7668960c95cde1bf73b5e40cd320e7.svg";
export { ForwardRef as ReactComponent };